<template>
  <div>
    <div v-if="!activeComponent">
      <div class="options">
        <div v-if="!showCodeInput" class="option">
          <input type="radio" id="code-yes" value="yes" v-model="invitationCodePicker" @change="activateOption" />
          <img src="@/assets/images/yes-invitation-code.svg" />
          <span v-if="!showCodeInput">{{ $t('teacher.yes') }}</span>
        </div>
        <div v-if="showCodeInput" class="option" id="code-option">
          <code-input :codeLength="5" :label="$t('teacher.enter_the_code')" @codeChanged="handleCode"/>
        </div>
        <div class="option">
          <input type="radio" id="code-no" value="no" v-model="invitationCodePicker" @change="activateOption" />
          <img src="@/assets/images/no-invitation-code.svg" />
          <span>{{ $t('teacher.no') }}</span>
          <span id="subtitle">{{ $t('teacher.teach_myself') }}</span>
        </div>
      </div>
      <primary-button ref="continue" @click.native="changeComponent" disabled>{{ $t('teacher.continue') }}</primary-button>
    </div>
    <component v-else :is="activeComponent" />
  </div>
</template>

<script>
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import CodeInput from '@/components/common/CodeInput'
  import { handleSubmitButtonState } from '@/helpers/formValidationHelper'
  import SetupOrganization from '@/views/SetupOrganization'

  export default {
    components: {
      PrimaryButton,
      CodeInput,
      SetupOrganization
    },
    data() {
      return {
        invitationCodePicker: '',
        showCodeInput: false,
        activeComponent: null,
        code: null
      }
    },
    methods: {
      activateOption(e) {
        const elementClasses = e.target.parentElement.classList
        if (!elementClasses.contains('active')) {
          const options = document.getElementsByClassName('option')
          for(let option of options) {
            option.classList.remove('active')
          }
          elementClasses.add('active')
          if (this.invitationCodePicker === 'yes') {
            this.showCodeInput = true
          } else {
            this.showCodeInput = false
            handleSubmitButtonState(this.$refs.continue.$el, true)
          }
        }
      },
      changeComponent() {
        this.$emit('confirmedCodePicker', { code: this.code, haveOrg: this.invitationCodePicker === 'yes' })
      },
      handleCode(codeObject) {
        const confirmButton = this.$refs.continue.$el
        if (codeObject.isValid) {
          this.code = codeObject.value.join('')
        }
        handleSubmitButtonState(confirmButton, codeObject.isValid)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/_colors.scss';

  ::v-deep .code {
    margin: 0;
    .heading label {
      font-weight: 600;
      font-size: 16px;
      color: $darker-blue;
    }
    .el-form-item__error {
      top: 0;
    }
    .elsa-input .el-input {
      display: block;
    }
  }

  .elsa-button {
    float: left;
    margin-top: 40px;
  }
  .options {
    display: grid;
    grid-template-columns: 437px 437px;
    grid-column-gap: 32px;
    margin-top: 32px;
    .option {
      border: 2px solid transparent;
      background-color: $lighter-gray;
      padding: 40px 20px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      &#code-option {
        display: flex;
        justify-content: center;
      }
      img {
        margin-bottom: 31px;
        width: 122px;
        height: 122px;
      }
      span {
        font-size: 18px;
        color: $dark-gray;
        text-transform: uppercase;
        font-weight: 600;
        &#subtitle {
          font-family: 'SF Pro Display';
          font-weight: normal;
          color: $dark-blue-2;
          text-transform: none;
        }
      }
      input {
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 111;
      }
      &.active {
        border: 2px solid $purple;
      }
    }
  }

</style>
